import React from 'react';
import { Page } from '../common/Page';
import { AccountHeaderBlock } from './AccountHeaderBlock';
import { PlanStateHeaderBlock } from './PlanStateHeaderBlock';

export const PageLoader = () => <>
    <Page.Header>
        <Page.HeaderPush>
            <PlanStateHeaderBlock />
            <AccountHeaderBlock />
        </Page.HeaderPush>
    </Page.Header>
    <Page.Content>
    </Page.Content>
</>;
